import { HttpErrorResponse } from '@angular/common/http';
import { NO_LICENSES_AVAILABLE_ERROR_DETAIL } from '@common';
import { get } from 'lodash';

export function isNoLicensesAvailable(error: HttpErrorResponse): boolean {
  const errorDetails = get(error, 'error.value', '') as string;
  return errorDetails?.replace(/\s+/g, '').toLowerCase() === NO_LICENSES_AVAILABLE_ERROR_DETAIL.toLowerCase();
}
